import factory from '../requestFactory';

export default ({diagnostic_type_id,clinic_id}) => {
    let params = {
        'diagnostic_type_id':diagnostic_type_id,
        'clinic_id':clinic_id,
    }
    return factory()
        .get('/diagnostics',{params:params});
}
